import axios from '@/api/requests/axios'

export default {
  getApplicationTypes: () => axios.get('/api/v1/dictionary/application-types'),
  getLanguages: () => axios.get('/api/admin/v1/languages'),
  getRoles: () => axios.get('/api/v1/dictionary/admin/roles'),
  getContactTypes: () => axios.get('/api/v1/dictionary/contact-types'),
  getContacts: () => axios.get('/api/v1/dictionary/contacts'),
  getApplicationDescriptionTypes: () => axios.get('/api/v1/dictionary/application-description-types'),
  getVacancyTypes: () => axios.get('/api/v1/dictionary/vacancy-types'),
  getSex: () => axios.get('/api/v1/dictionary/sex'),
  getCounterPartyTypes: () => axios.get('/api/v1/dictionary/counter-party-types'),
  getOrderTypes: () => axios.get('/api/v1/dictionary/order-types'),
  getPaymentMethods: () => axios.get('/api/v1/dictionary/payment-methods'),
  getVacancyApplicationStatuses: () => axios.get('/api/v1/dictionary/vacancy-application-statuses'),
  getPaymentMethodTypes: () => axios.get('/api/v1/dictionary/payment-method-types'),
  getDeliveryPaymentTypes: () => axios.get('/api/v1/dictionary/delivery-payment-types'),
  getTransferKinds: () => axios.get('/api/v1/dictionary/transfer-kinds'),
  getPaymentAmountScopes: () => axios.get('/api/v1/dictionary/payment-amount-scopes'),
  getBranches: () => axios.get('/api/v1/dictionary/branches'),
  getOrderStates: () => axios.get('/api/v1/dictionary/order-states'),
  getCustomDishTypes: () => axios.get('/api/v1/dictionary/custom-dish-types'),
}
